import React from "react";
import { BaseIcon } from "@/shared/components/icon/base-icon";
import { Icon, IconType } from "@/shared/config/globals";

interface Props {
  passbookName: string; // 明細帳名
  passbookType: string; // 明細帳タイプ（口座タイプ）
}

export const MyGroupElement = (props: Props) => {
  const setIconType = (passbookType: string): IconType => {
    if (passbookType === "01") {
      return Icon.Bank_Black;
    } else if (passbookType === "03" || passbookType === "19659" || passbookType === "19660") {
      return Icon.Creca_Black;
    } else if (passbookType === "10") {
      return Icon.ElectronicMoney_Black;
    } else if (passbookType === "20") {
      return Icon.EcShop_Black;
    } else if (passbookType === "101") {
      return Icon.Ocr_Black;
    } else if (passbookType === "201") {
      return Icon.CSV_Black;
    } else {
      return Icon.Question_Black;
    }
  };
  // 明細帳タイプに応じたボタンのclass名を返す
  // 再修正の可能性あり
  const buttonType = (passbookType: string): any => {
    if (passbookType === "01") {
      return {buttonType: "type-bank", accountType: "API連携"};
    } else if (passbookType === "03" || passbookType === "19659" || passbookType === "19660") {
      return {buttonType: "type-card", accountType: "API連携"};
    } else if (passbookType === "10") {
      return {buttonType: "type-emoney", accountType: "API連携"};
    } else if (passbookType === "20") {
      return {buttonType: "type-ecshop", accountType: "API連携"};
    } else if (passbookType === "101") {
      return {buttonType: "type-ocr", accountType: "OCR読み込み"};
    } else if (passbookType === "201") {
      return {buttonType: "type-csv", accountType: "CSV読み込み"};
    } else {
      return {buttonType: "", accountType: "Excel読み込み"};
    }   
  };

  return (
    <dl className={buttonType(props.passbookType).buttonType}>
      <dt>
        {props.passbookName}
      </dt>
      <dd>
        <p>{buttonType(props.passbookType).accountType}</p>
      </dd>
    </dl>
  );
};